import { Link } from "react-router-dom";
import { site } from "@/config/site";

const stats = [
  { value: "12,800+", label: "累计收到线索" },
  { value: "850+", label: "已发布爆料" },
  { value: "12 小时", label: "初筛反馈时效" },
  { value: "默认加密", label: "投稿人信息" },
];

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20textured%20backdrop%20resembling%20archival%20paper%20and%20redacted%20documents%20with%20warm%20amber%20light%20leaks%20and%20deep%20shadows%2C%20cinematic%20grainy%20editorial%20photography%2C%20no%20text&width=1600&height=900&seq=hero-kanliao-01&orientation=landscape"
          alt="看料爆料匿名线索投稿平台的档案纸张质感背景"
          title="看料爆料 - 匿名投稿平台"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/70 to-foreground-950/90"></div>

      <div className="relative mx-auto w-full max-w-shell px-4 py-20 md:px-6 md:py-28 lg:py-32">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3.5 py-1.5 text-xs tracking-wide text-background-100 backdrop-blur">
            <i className="ri-shield-keyhole-line text-sm text-accent-300" aria-hidden="true"></i>
            匿名投稿 · 快速核实 · 安全发布
          </span>

          <h1 className="mt-6 font-heading text-3xl font-black leading-tight tracking-tight text-background-50 md:text-5xl lg:text-6xl">
            把内幕交给我们，
            <span className="text-accent-400">让猛料安全见光</span>
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-200 md:text-lg">
            {site.intro}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/submit"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-500 md:text-base"
            >
              <i className="ri-mail-send-line text-lg" aria-hidden="true"></i>
              我要投稿 / 提交线索
            </Link>
            <Link
              to="/scoops"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 md:text-base"
            >
              <i className="ri-newspaper-line text-lg" aria-hidden="true"></i>
              浏览最新爆料
            </Link>
          </div>
        </div>

        <dl className="mt-14 grid grid-cols-2 gap-x-6 gap-y-8 border-t border-background-50/15 pt-8 md:grid-cols-4">
          {stats.map((item) => (
            <div key={item.label}>
              <dt className="font-heading text-2xl font-bold text-background-50 md:text-3xl">{item.value}</dt>
              <dd className="mt-1.5 text-xs text-background-300 md:text-sm">{item.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}